import React from 'react'

const Pets = () => {
  return (
      <svg
          width="30px"
          height="30px"
          viewBox="0 0 1024 1024"

      >
          <path
              className="rui-10_kq"
              d="M653.689 147.951l168.004 35.403 99.123 140.646-104.437 161.363-24.699 166.528-48.766 44.876v80.131l-78.051 100.6h-291.644l-78.521-105.184 0.336-75.789-50.86-37.2-53.461-171.971-99.76-163.964 98.543-139.806 162.335-35.46 301.86-0.167zM668.063 715.029h-298.247l-0.149 32.58 41.095 55.034h217.445l39.859-51.368v-36.246zM625.751 222.82l-249.539 0.13-111.211 251.167 43.32 139.375 36.472 26.684h349.054l27.675-25.451 20.378-137.43-116.152-254.479zM560.227 494.238v19.798l-55.651 50.581-54.605-48.092v-22.288h110.258zM714.622 237.285l71.616 156.89 44.277-68.377-53.050-75.262-62.838-13.248zM618.824 353.349c10.647 0 19.275 8.644 19.275 19.275 0 10.665-8.626 19.313-19.275 19.313s-19.295-8.644-19.295-19.313c0-10.627 8.644-19.275 19.295-19.275zM380.916 353.349c10.647 0 19.295 8.644 19.295 19.275 0 10.665-8.644 19.313-19.295 19.313s-19.295-8.644-19.295-19.313c0-10.627 8.644-19.275 19.295-19.275zM287.553 238.315l-53.5 12.013-53.649 76.086 39.447 64.822 67.702-152.923z"
          ></path>
      </svg>
  )
}

export default Pets
